import { render, staticRenderFns } from "./Baseline.vue?vue&type=template&id=4820d304&"
import script from "./Baseline.vue?vue&type=script&lang=js&"
export * from "./Baseline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports